import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { KPI_MAP, DEFAULT_KPI_IDS } from './kpiRegistry';
import { useKPIData } from './useKPIData';
import { formatValue } from '../utils/formatValue';
import KPICard from './KPICard';

const DOMAIN_LABEL_KEY = {
  fuel:        'domain_fuel',
  oc:          'domain_oc',
  tco:         'domain_tco',
  utilization: 'domain_utilization',
  inspections: 'domain_inspections',
  workorders:  'domain_workorders',
};

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ $count }) => $count}, 1fr);
  gap: 12px;
  margin-bottom: 24px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export default function KPIBar({ activeIds = DEFAULT_KPI_IDS, filters }) {
  const { t } = useTranslation('common');
  const { data, loading } = useKPIData(activeIds, filters);
  const storeUnits = useSelector((state) => state.units);

  return (
    <Grid $count={activeIds.length}>
      {activeIds.map((id, index) => {
        const config = KPI_MAP[id];
        if (!config) return null;

        const kpiData = data[id] ?? { value: 0, trend: {}, subLabel: '' };
        const formattedValue = formatValue(kpiData.value, config.valueFormat, storeUnits);
        //const severity = config.severity(kpiData.value);

        return (
          <KPICard
            key={id}
            label={t(config.labelKey, { defaultValue: config.label })}
            value={formattedValue}
            trend={kpiData.trend}
            subLabel={kpiData.subLabel}
            upIsBad={config.upIsBad}
            loading={!!loading[id]}
            domain={config.domain}
            categoryLabel={t(DOMAIN_LABEL_KEY[config.domain] ?? config.domain)}
          />
        );
      })}
    </Grid>
  );
}
